import BaseHttpService from "./https.service";

class ConfigHttpService extends BaseHttpService {
  constructor() {
    super('');
  }

  async getUserCheck(uid, appId) {
    return await this.get(`/user-check`, { uid, aid: appId });
  }
}

export const configService = new ConfigHttpService();
